import * as io from 'io-ts';

export const arrayOfNumbers = io.array(io.number);
export const nullableArrayOfNumbers = io.union([arrayOfNumbers, io.null]);
